// extracted by mini-css-extract-plugin
export var wordContainer = "_s3-0";